import * as NotificationActions from './notification.actions';

export interface State {
  userNotifications: NotificationDto[];
  channelNotifications: NotificationDto[];
}

/**
 * The reducer acts on actions as defined below, and is the only way to update state.
 *
 * @param {State} state: the initial state of the redux sub-store
 * @param {NotificationAction} action: the actions that this sub-store is managing
 * @returns {any} updated state of the redux sub-store
 */
export function notificationReducer(state: State = {
  userNotifications: undefined,
  channelNotifications: undefined
},
action: NotificationActions.NotificationAction) {
  switch (action.type) {
  case NotificationActions.UPDATED_USER_NOTIFICATION:
    return {
      ...state,
      userNotifications: action.payload
    };
  case NotificationActions.UPDATED_CHANNEL_NOTIFICATION:
    return {
      ...state,
      channelNotifications: action.payload
    };
  default:
    return state;
  }
}
